import Fader from 'static-components/src/fader';
var initializeFader = function () {
    var faderElement = document.querySelector('.js-fader');
    if (faderElement) {
        new Fader(faderElement);
    }
};
export default initializeFader;
